import { Redirect, useHistory } from 'react-router-dom';

import {
  hasApproverSubNav,
  SubnavigationItem,
} from 'modules/requests/utils/navigation';
import { routeFor, routes } from 'src/core/constants/routes';
import { useCompany } from 'src/core/modules/app/hooks/useCompany';
import { useUser } from 'src/core/modules/app/hooks/useUser';

import styles from './Homepage.module.css';
import { WelcomePanel } from './components/WelcomePanel';
import { useDisplayMode } from './hooks';
import { ControllerHomepage } from '../ControllerHomepage';
import { RequesterHomepage } from '../RequesterHomepage';

const getRequestsLink = (
  user: {
    is_approver: boolean;
    is_account_owner: boolean;
  },
  companyId: string,
): string => {
  const type = hasApproverSubNav(user)
    ? SubnavigationItem.ToApprove
    : SubnavigationItem.All;

  return routeFor(routes.REQUESTS.path, {
    type,
    company: companyId,
  });
};

export const Homepage = () => {
  const history = useHistory();

  const user = useUser();
  const company = useCompany();
  const displayMode = useDisplayMode();

  if (!displayMode) {
    if (company.churning_at) {
      const path =
        user.is_account_owner || user.is_controller || user.is_requester
          ? routes.PAYMENTS_ALL.path
          : routes.COMPANY_MEMBERS.path;
      return (
        <Redirect
          to={{
            pathname: routeFor(path, { company: company.id }),
            search: history.location.search,
          }}
        />
      );
    }

    if (!user.is_requester && user.is_admin) {
      const settingsLink = routeFor(routes.COMPANY_MEMBERS.path, {
        company: company.id,
      });
      return (
        <Redirect
          to={{
            pathname: settingsLink,
            search: history.location.search,
          }}
        />
      );
    }

    return (
      <Redirect
        to={{
          pathname: getRequestsLink(user, company.id),
          search: history.location.search,
        }}
      />
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <WelcomePanel />
        <div>
          {displayMode === 'controller' ? (
            <ControllerHomepage />
          ) : (
            <RequesterHomepage />
          )}
        </div>
      </div>
    </div>
  );
};
